import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo } from '@/components/brand/Logo';

const FooterLink = ({ children, onClick }) => (
  <button
    onClick={onClick}
    className="text-[14px] text-cream-100/70 hover:text-cream-50 transition-colors text-left"
  >
    {children}
  </button>
);

const FooterColumn = ({ title, children }) => (
  <div>
    <h4 className="eyebrow text-cream-100/70 mb-4">{title}</h4>
    <ul className="space-y-2.5">{children}</ul>
  </div>
);

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="bg-ink text-cream-50 mt-auto">
      {/* Top — brand promise */}
      <div className="container-page pt-20 pb-14 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <Logo markSize={30} tone="cream" />
          <p className="mt-5 max-w-sm text-cream-100/75 leading-relaxed">
            A quiet place to gather everything for the moments that matter most.
            Beautifully simple, endlessly personal — and always free for you and your guests.
          </p>
          <div className="mt-7 inline-flex items-center gap-2 text-xs text-cream-100/60 px-3 py-1.5 rounded-full bg-cream-50/5 border border-cream-50/10">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-sage-200 animate-pulse" />
            All transactions secure and encrypted
          </div>
        </div>

        <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
          <FooterColumn title="Discover">
            <li><FooterLink onClick={() => navigate('/baby-registry-guide')}>Baby registry guide</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/how-it-works')}>How it works</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/explore-gifts')}>Explore gifts</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/ask-jb')}>Ask JB · AI companion</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/search-registry')}>Find a registry</FooterLink></li>
          </FooterColumn>

          <FooterColumn title="Company">
            <li><FooterLink onClick={() => navigate('/contact')}>Contact</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/pricing')}>Pricing</FooterLink></li>
          </FooterColumn>

          <FooterColumn title="Legal">
            <li><FooterLink onClick={() => navigate('/privacy')}>Privacy</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/terms')}>Terms</FooterLink></li>
            <li><FooterLink onClick={() => navigate('/refund-policy')}>Returns &amp; refunds</FooterLink></li>
          </FooterColumn>
        </div>
      </div>

      {/* Bottom — quiet line */}
      <div className="border-t border-cream-50/10">
        <div className="container-page py-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-[13px] text-cream-100/55">
          <p>&copy; {new Date().getFullYear()} Joy Basket. Made with care, in India.</p>
          <p className="font-display italic">
            "It made the lead-up less anxious."
          </p>
          <p>
            <a href="mailto:support@joy-basket.com" className="hover:text-cream-50 transition-colors">
              support@joy-basket.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
